/* Chelsea and Rachel Co. 2024 */


class CnR {
    
  api_version = "2024-04";
  keyname = "subscriptions-2024-02";
  constructor(opts={}) {
      this.config = {...this.defaults(),...opts};
      this.inject_css()
      
  }
  defaults() {
    return {
      api_version:"2023-07",
      keyname:"subscriptions-2024-02"
    };
  }
  fetch(url,config) {
    if (this.config.fetch_function) {
      return pure_fetch(url,config)
    } else {
      return fetch(url,config)
    }
  }
  /* shopify cart functions */
  async getCart(url="/cart.js",extended=false,callback=()=>{}) {
      let cart = {};
      return this.fetch(url) 
    .then(res=>(extended)?res.text():res.json());
  }
  async request(url) {
      return this.fetch(url).then(text=>response.text())
  }
  async updateCart(payload) {
    return this.fetch(`/cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(payload)
    }).then((response) => response.json());
 }
  async removeItemFromCart(key) {
      return this.changeCart({
          id:key,
          quantity:0
        })
  }
  async updateItemCount(key,quantity) {
    return this.changeCart({
      id:key,
      quantity:parseInt(quantity)
    })
  }
  async changeCart(payload) {
      return this.fetch(`/cart/change.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(payload)
        }).then((response) => response.json());
   }
   async addToCart(payload) {
      let config = {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
      }
      return this.fetch("/cart/add.js",config)
          .then((response) => response.json())
   }
   
   static setupDawnProductForm(form) {
      form.querySelector("button").addEventListener("click",event=>{
         event.preventDefault();
         event.stopPropagation();
         new CnR().addToDawnCart(form).then(response=>{
           
       });
      });
    }
    async addToDawnCart(form) {

       let cart = document.querySelector("cart-drawer");
       const formData = new FormData();
       formData.append('product-id',form.dataset.productId);
       formData.append("id",form.querySelector('[name="id"]').value)
       formData.append("quantity",1);
       try {
         formData.append("selling_plan",form.querySelector('[name="selling_plan"]').value);  
       } catch(e) {}
       
       formData.append('sections',cart.getSectionsToRender().map((section) => section.id));
       formData.append('sections_url',form.dataset.url);
       formData.append('form_type','product');
       
       return this.fetch("/cart/add",{
           method: 'POST',
           headers: {
               "Accept":"application/javascript",
               "X-Requested-With":"XMLHttpRequest"
           },
           body: formData,form
       })
           .then((response) => response.json())
           .then(json=>{
             
             
             if (json.status) {
               CnRModal.show(json.description);
             } else {
               cart.renderContents(json);
               cart.classList.remove("is-empty")
             }
             return json;
       });
    }

   /* graphql functions */
   async graphql(query,params) {
      
      return fetch(`/api/${this.api_version}/graphql.json`,{
          method:"POST",
          headers:{
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
            },
            body:JSON.stringify({query:query,variables:params})
          })
          .then(response=>{
            let responseJson = response.json()
            return responseJson;
          })
  }
  graphql_sync(query,params) {
      let ajax = new XMLHttpRequest();
      ajax.headers = {
          "content-type":"application/json",
          "X-Shopify-Storefront-Access-Token":this.config.graphql_token
      }
      ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
      ajax.setRequestHeader("Content-Type", "application/json");
      ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
      ajax.send(JSON.stringify({query:query,params:params}));
      return JSON.parse(ajax.responseText);
  }
  gid2id(gid) {
    return parseInt(gid.split("/").pop())
  }
  collapse_query(object) {
    if (object==null) {
        return object;
    }
    switch(object.constructor.name) {
    case "Array":
        return object.map(item=>this.collapse_query(item));
        break;
        case "Object":
            let ret = {};
            Object.keys(object).forEach(key=>{
                if (object[key]==null) {
                    ret[key] = null;
                    return;
                }
                if (object[key].reference) {
                    ret[key] = this.collapse_query(object[key].reference)
                    return;
                    
                }
                if (object[key].references) {                        
                    let all = [];
                    object[key].references.nodes.forEach(ref=>{
                        let crv = {};
                        ref.fields.forEach(field=>{
                            crv[field.key]=this.collapse_query(field.value)
                        })
                        all.push(crv)
                    })
                    object[key] = all;
                    
                }
                if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                    ret[key] = this.collapse_query(object[key].nodes);
                } else {
                    ret[key] = this.collapse_query(object[key])
                }
            });
            return ret
            break;
        default:
            if (object) {
                return object;
            }
            
            break;
    }
}     
   css() {
      return '';
   }
   inject_css() {
      let css = this.css();
      if (css.length>0) {
          let style = document.createElement("style");
          style.id=this.constructor.name.toLowerCase();
          style.textContent = this.css();
          document.querySelector("head").appendChild(style);
      }
      
   }
}
/* cnr-sorcistino/sorcistino.js  */
/* Copyright 2023 Chelsea and Rachel Co */
class Sorcistino extends CnR {
    defaults() {
        return {
            injection_point:".sorcistino-holder",
            zeroButtonBehavior: "hide",
            class:"sorcistino",
        }
        
    }
    constructor(options) {
        super(options)
        this.screens = [];
        this.screen = 0;
        this.data = {};
        this.screens_data = {}
        this.screenTitles = []
        this.root = document.querySelector(this.config.injection_point);
        this.load_data();
        this.uuid = crypto.randomUUID();
    }
    query() {
        return ``;
    }
    additionalVariantQuery() {
        return ``
    }
    additionalProductQuery() {
        return ``
    }
    productQuery() {
     return `
            query getProducts($id: ID!) {
                product(id:$id) {
                    id
                    variants(first:100) {
                        nodes {
                            id
                            price {
                                amount
                            }
                            ${this.additionalVariantQuery()}
                        }
                    }
                    ${this.additionalProductQuery()}
                    sellingPlanGroups(first: 10) {             
                        nodes {
                            appName
                            name
                            sellingPlans(first:250) {
                                nodes {  
                                    recurringDeliveries
                                    id
                                    options {
                                        value
                                    }
                                    description
                                    priceAdjustments {
                                        adjustmentValue {
                                            ... on SellingPlanPercentagePriceAdjustment {
                                                percent: adjustmentPercentage
                                            }
                                            ... on SellingPlanFixedPriceAdjustment {
                                                amount: price {
                                                    amount
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`
    }

    addScreen(data,index) {
        this.screens.push(new SorcistinoScreen(this,data,index))
    }
    render(startingScreen=0) {
        this.root.innerHTML = `
            <div class="sorcistino-holder ${this.config.class}">
                <div class="header">
                    <div class="title"></div>
                    <div class="progress">
                        <div class="progress-bar-wrapper js-progress-bar-wrapper">
                            <div class="progress js-progress" style="width: 0%;"></div>
                        </div>
                    </div>
                    <div class="nav">
                         <ul class="sorcistino-nav-menu">
                            <div class="sorcistino-nav-holder">
                                <button class="sorcistino-nav-button cta grid-item-cta cta-foreward-lite-primary" data-screen-nav="back" disabled>Back</button>
                                <button class="sorcistino-nav-button cta grid-item-cta cta-foreward-lite-primary" data-screen-nav="next" disabled>Next</button>
                            </div>
                         </ul>
                    </div>
                </div>
                <div class="content"></div>
                <div class="footer">${this.renderFooter()}</div>
            </div>    
        `
        this.setupEvents();
        document.dispatchEvent(new CustomEvent("sorcistino:rendered",{bubbles:true,detail:this}))
        this.show(startingScreen)
    }
    renderFooter() {
        return ``
    }
    setupEvents() {
        this.root.querySelectorAll(".sorcistino-nav-button").forEach(button=>button.addEventListener("click",event=>this.navigate(button)))
    }
    navigate(nav) {
      
      if (nav.getAttribute("data-screen-nav")=="back") {
        this.show(this.screen-1);
      } else {
        this.show(this.screen+1);
      }
    }
    next() {
      if (this.screen+1<this.screens.length) {
        this.show(this.screen+1);
      }
    }
    prev() {
      if (this.screen-1>=0) {
        this.show(this.screen-1);
      }
    }
    setNextVisibility(show=true) {
      let root = document.querySelector(this.config.injection_point);
      console.error(root)
      try {
        if (show) {
            root.querySelector('[data-screen-nav="next"]').disabled = false;
            
        } else {
            root.querySelector('[data-screen-nav="next"]').disabled = true;
        }
      } catch(e) {
       console.error(e)
      }
        
    }
    setBackVisibility(show=true) {
      let root = document.querySelector(this.config.injection_point);
      try {
        if (show) {
            root.querySelector('[data-screen-nav="back"]').disabled = false;
        } else {
            root.querySelector('[data-screen-nav="back"]').disabled = true;
        }
      } catch (e) {
        
      }
        
    }
    setProgress(perc) {
        let root = document.querySelector(this.config.injection_point);
        root.querySelector(".js-progress").style.width=`${Math.floor(perc*100)}%`
    }
    currentScreen() {
        return this.screens[this.screen];
    }
    renderScreen() {
        this.currentScreen().render()
    }
    setScreen(index) {
        this.screen = index;
        return this.currentScreen()
    }
    setContent(content) {
      this.root.querySelector(".content").innerHTML = content;
    }
    show(screen) {
        
        this.screen = screen;
        if (screen<0) {
            this.screen = 0;
            document.dispatchEvent(new CustomEvent("sorcistino:reset",{bubbles:true,detail:this}))
            return;
        }
      
        if (this.screen==0) {
            document.querySelectorAll(".sorcistino-nav-holder").forEach(nav=>nav.removeAttribute("hidden"));
        }
        let screenObj = this.setScreen(screen)
        
       
        if (screen>=0 && screen<=this.screens.length) {
            screenObj.render()
            screenObj.setupEvents();
        }
        if (this.root.querySelector(".title")) {
            this.root.querySelector(".title").innerHTML = screenObj.title();
        }
        
        if (this.screen>0) {
             this.setBackVisibility(true)
        } else {
            if (this.config.zeroButtonBehavior=="hide") {
                this.setBackVisibility(false)
            } else {
              this.setBackVisibility(true)
            }
        }
      
        //\/ Nav Buttons
        if (this.screen+1<this.screens.length && screenObj.completed()) {
            this.setNextVisibility(true)
        } else {
            this.setNextVisibility(false)
        }
        if (screen==0) {
            this.setProgress(0.05);
        } else if (screen==this.screens.length-1) {
            this.setProgress(1)
        } else {
          this.setProgress((screen/(this.screens.length-1))+0.05)
        }
        document.dispatchEvent(
            new CustomEvent("sorcistino:screen:changed",{bubbles:true,detail:this})
         );
        
        if (this.isFinalScreen()) {
            this.finalize();
            
            
        }
    }
    broadcastFinal() {
      document.dispatchEvent(
        new CustomEvent("sorcistino:screen:final",{bubbles:true,detail:this})
      );
    }
    isFinalScreen() {
        return this.screen == this.screens.length-1;

    }
    load_data() {

    }
    finalize() {
        
    }
}
class SorcistinoScreen {
    constructor(parent,data,index) {        
        this.index = index;
        this.parent = parent;
        this.data = data;
        this.is_completed = false;
        this.uuid = crypto.randomUUID()
    }
    setupEvents() {

    }
    completed() {   
        return this.is_completed;
    }
    complete() {
      return this.is_completed=true;
    }
    data() {
        return this.data;
    }
    is_final() {
      return this.screen.hasAttribute("data-final-screen");
    }
    render() {
        return ``
    }
    preserve() { return false;}
}
/* tykables.js  */
class TykablesSubscription extends Sorcistino {
    constructor(options) {
        super(options);
        this.data.options = []
        this.data.selectedOptions = []
        this.data.optionValues = []
        this.data.selectedVariant = [];
        this.data.variants = []
        this.data.sellingPlans = [];
        this.data.product = [];
        this.screens = [];
        document.addEventListener("sorcistino:update:price",event=>{
          
          document.querySelector(".js-box-price span").innerHTML = event.detail.toFixed(2)
        })
      
    }
    widgetTitle() {
      return this.config.title;
    }
    isMultiProduct() { return false}
    load_data() {
      this.getProduct(this.config.product);
    }
    getProduct(id) {
        this.graphql(this.query(),{id:`gid://shopify/Product/${id}`}).then(q=>{
            console.error(q)
            this.initProduct(q);
        })
    }
    selectedVariant(index=0,withOptions = null) {
      let signature = this.data.selectedOptions[index].join("|");
      if (withOptions) {
        signature = withOptions.join("|")
      }
      return this.data.variants[index].find(variant=>variant.signature==signature)||this.data.variants[index][0]
    }
    mapVariants(product) {
      return product.variants.nodes.map(variant=>{
        return {
          "id":this.gid2id(variant.id),
          signature: variant.selectedOptions.map(option=>option.value).join("|"),
          options:variant.selectedOptions.map(option=>option.value),
          option_names:variant.selectedOptions.map(option=>option.value),
          price:parseFloat(variant.price.amount),
          available: variant.availableForSale,
          mapTo:variant.mapTo?{id:this.gid2id(variant.mapTo.value),price:variant.mapTo}:null
        }
      });
      
    }
    setProduct(product,index=0) {
      this.data.product[index] = product;
      this.data.options[index] = this.data.product[index].options;
      this.data.optionValues[index] = this.data.product[index].options.map(opt=>opt.name);
      this.data.variants[index] = this.mapVariants(this.data.product[index])
      
      this.data.sellingPlans[index] = [];
      this.data.product[index].sellingPlanGroups.nodes.forEach(group=>group.sellingPlans.nodes.forEach(plan=>{
        this.data.sellingPlans[index].push({
          id:this.gid2id(plan.id),
          label:plan.options[0].value,
        });
      }))
      this.data.selectedOptions[index] = this.data.variants[index][0].options;
      
      
    }
    init(q) {
      
      this.initProduct(q)
    }
    initProduct(q) {
      
      this.data.parentProduct = q.data.product;
      this.data.parentVariants = this.mapVariants(q.data.product);
      this.data.selectedParentVariant = this.data.parentVariants[0]
      this.data.parentSellingPlans = []
      this.data.parentProduct.sellingPlanGroups.nodes.forEach(group=>group.sellingPlans.nodes.forEach(plan=>{
        this.data.parentSellingPlans.push({
          id:this.gid2id(plan.id),
          label:plan.options[0].value,
        });
      }))
      this.data.children = []
      if (this.data.parentProduct.childProducts) {
        this.data.children = this.data.parentProduct.childProducts.products.nodes;
        this.data.children.forEach((child,index)=>this.setProduct(child,index));
      } else {
          console.error(this.data.parentProduct)
          this.setProduct(this.data.parentProduct,0);
      }
      
      if (this.screens.length>0) {
        if (this.screens[0].preserve()) {
          this.screens = [this.screens[0]];
        } else {
          this.screens = [];
        }
      }
      
      let startingIndex = this.screens.length;
      this.data.product.forEach((product,productIndex)=>{
        this.data.options[productIndex].forEach((option,index)=>{
          this.screens.push(
            new TykablesSubscriptionScreen(
            this,
            {
              option:option.name,
              title:`Choose your ${option.name}`,
              values: option.values,
              index:index,
              productIndex:productIndex
            },
            index+startingIndex
          ));  
        });
      });
      this.screens.push(new TykablesSubscriptionFinalScreen(
        this,
        {
          "title":"Need anything else?",
          index:this.screens.length,
        },
        this.screens.length,
      ))
      this.screen = 0;
      
      this.render(startingIndex)
    }
    additionalProductQuery() {
        return `
            options(first:3) {
              name
              values
            }
            descriptionHtml
            rating: metafield(namespace:"judgeme",key:"badge") {
                value
            }
            title
            description: metafield(namespace:"cnr",key:"product_description") {
                value
            }
            childProducts: metafield(namespace:"gearbox",key:"products") {
              products: references(first:10) {
                nodes {
                  ... on Product {
                    id
                    variants(first:100) {
                        nodes {
                            id
                            price {
                                amount
                            }
                            title
                            availableForSale
                            selectedOptions {
                              name
                              value
                            }
                            mapTo: metafield(namespace:"cnr",key:"map_to_subscription_variant") {
                              value
                              reference {
                                ... on ProductVariant {
                                  id
                                  price {
                                    amount
                                  }
                                }
                              }
                            }
                        }
                    }
                    sellingPlanGroups(first: 10) {             
                        nodes {
                            appName
                            name
                            sellingPlans(first:250) {
                                nodes {  
                                    recurringDeliveries
                                    id
                                    options {
                                        value
                                    }
                                    description
                                    priceAdjustments {
                                        adjustmentValue {
                                            ... on SellingPlanPercentagePriceAdjustment {
                                                percent: adjustmentPercentage
                                            }
                                            ... on SellingPlanFixedPriceAdjustment {
                                                amount: price {
                                                    amount
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                  }
                  options(first:3) {
                    name
                    values
                  }
                  descriptionHtml
                  rating: metafield(namespace:"judgeme",key:"badge") {
                    value
                  }
                  title
                  description: metafield(namespace:"cnr",key:"product_description") {
                    value
                  }
                  featuredImage {
                    url
                  }      
                }
              }
            }
          }
          featuredImage {
            url
          }
        `
    }
    additionalVariantQuery() {
      return `
        title
        availableForSale
        selectedOptions {
          name
          value
        }
        mapTo: metafield(namespace:"cnr",key:"map_to_subscription_variant") {
          value
          reference {
            ... on ProductVariant {
              id
            }
          }
        }
      `
    }
    query() {
        return this.productQuery()
    }
    finalize() {
      let selectedVariantId = this.selectedVariant(0).id;
      this.addToCart(
        {
          items:[{
            id:selectedVariantId,
            selling_plan: (this.data.parentSellingPlans && this.data.parentSellingPlans.length>0)?this.data.parentSellingPlans[0].id:null,
            quantity:1,
            }
          ]
        }
      ).then(res=>{
        this.broadcastFinal();
      });
    }
    imageFor(index=0) {
      if (this.data.product[index].featuredImage) {
        return this.data.product[index].featuredImage.url
      }
    }
    displayPrice() {
      return this.selectedVariant().price.toFixed(2)
    }
    screenCount() {
      return screens.length()
    }
    widgetTitle() {
      return "Subscriptions";
    }
    
}

class TykeablesGearBox extends TykablesSubscription {
  load_data() {
    this.graphql(
      `
      query getConfig($handle:MetaobjectHandleInput) {
        config: metaobject(handle:$handle) {
          handle
          name: field(key:"name") {
            value
          }
          media: field(key:"group_image") {
            entry: reference {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
          styles: field(key:"parent_products") {
            value
            products: references(first:3) {
              nodes {
                __typename
                ... on Product {
                  title
                  id
                  options(first:3) {
                    name
                    values
                  }
                } 
              }
            }
          }
        }
      }
      `,
      {handle:{handle:this.config.group,type:'gear_box_groups'}}
    ).then(q=>{
      console.error(q)
      this.init(q);
    })
  }
 
  init(q) {
    console.error(q)    
    this.data.q = q;
    this.data.image = q.data.config.media?q.data.config.media.entry.image.url:'';
    this.data.productsList = q.data.config.styles.products.nodes.map(node=>{
            return {id:this.gid2id(node.id),title:node.title}
    });
    if (this.data.productsList.length>1) {
      this.screens.push(
        new TykablesGearSelectionScreen(
          this,
          {
            products:this.data.productsList,
            title:"Select your Style",
          },
          0
        )
      )
      this.render()  
    } else {
      this.getProduct(this.data.productsList[0].id)
    }
    
  }
  imageFor(index=0) {
    return this.data.image;
  }
  displayPrice() {
    return this.data.selectedParentVariant.price.toFixed(2)
  }
  screenCount() {
    return this.childProducts.reduce((a,b)=>a+b.reduce)
  }
  finalize() {
      
      let selectedVariantId = this.gid2id(this.data.parentProduct.variants.nodes[0].id);
      this.data.product.forEach((child,index)=>{
        let variant = this.selectedVariant(index);
        if (variant.mapTo!=null) {
          selectedVariantId = variant.mapTo.id;
          this.data.selectedParentVariant = this.data.parentVariants.find(variant=>variant.id==selectedVariantId)
          document.dispatchEvent(new CustomEvent("sorcistino:update:price",{bubbles:true,detail:this.data.selectedParentVariant.price}))
        }
      });
      this.addToCart({
        items:[
          {
            id:selectedVariantId,
            selling_plan: (this.data.parentSellingPlans && this.data.parentSellingPlans.length>0)?this.data.parentSellingPlans[0].id:null,
            properties:{
              _bundleParentID:this.uuid,
              _bundleContents:this.data.product.map((child,index)=>this.selectedVariant(index).id),
              _bundleType:"gearboxv2",
            },
            quantity:1,
          }
        ]
      }).then(res=>{
        this.broadcastFinal();
      });
    }
}

class TykablesSubscriptionScreen extends SorcistinoScreen {
    render() {
      let product = this.parent.data.product[this.data.productIndex]
      this.parent.setContent(`
        <div class="panels" data-uuid="${this.uuid}">
          <div class="rounded-section db-column db-image-column js-db-image-column d-flex justify-content-center align-items-center">
            <div class="image-wrapper js-image-wrapper">
              <img src="${this.parent.imageFor(this.data.productIndex)}" alt="" width="537" height="538" class="no-pointer-events">
            </div>
          </div>
          <div class="rounded-section db-column db-main-column js-main-column d-flex justify-content-center align-items-center">
            <div class="inner">
              <div class="eyebrow color-poppy h5">
                Subscriptions
              </div>
              <h2 class="h1 db-heading first-heading js-first-heading">
                ${product.title}
              </h2>
              <div class="h1 db-heading last-heading js-last-heading d-none"></div>
                <div class="review-app-wrapper body2 pdp-stars">${product.rating.value}</div>
                <h3 class="h5 choose-option js-choose-option-Size js-choose-option">Choose ${this.data.option}</h3>
                  <div class="switch-field js-switch-field switch-field-Size">
                    ${this.data.values.map(value=>{
                      let optionId = `${this.data.option}-${value}`;
                      ['"','/',' ','(',')','[',']'].forEach(str=>{
                        optionId = optionId.replaceAll(str,"-")
                      })
                      return `
                      <input type="radio" id='${optionId}' name="option-${this.data.option}" value='${value}' class="js-variant-button variant-button js-variant-button0-radio1" data-option-name="${this.data.option}" data-option-index="${this.index}" data-product-index="${this.data.productIndex}" ${value==this.data.selectedValue?' checked':''}>
                      <label for='${optionId}' class="cta">${value}</label>
                      `}).join("\n")}
                    </div>
                    <div class="price-add-wrapper d-flex w-100 justify-content-between align-items-center flex-wrap flex-lg-nowrap">
                      <span class="h3 db-box-price js-box-price d-block js-summary-price">$<span class="money">${this.parent.displayPrice()}</span></span>
                    </div>
                    <div class="body2 body-copy textile js-body-copy">
                      <div class="js-hero-copy"><p>${product.description?product.description.value.split("\n").map(para=>`<p>${para}</p>`).join("\n"):''}</p></div>
                        <div class="d-none js-last-copy"></div>
                      </div>
                    </div>
                  </div>
                </div>
      `);

    }
    screenRoot() {
      return document.querySelector(`[data-uuid="${this.uuid}"]`);
    }
    setupEvents() {
      let screenRoot = this.screenRoot();
      if (screenRoot) {
        screenRoot.querySelectorAll("input").forEach(option=>{
          option.addEventListener("click",event=>{
            this.data.selectedValue = option.value;
            this.parent.data.selectedOptions[this.data.productIndex][this.data.index] = option.value;

            this.is_completed = true;
            this.parent.next()
          })
        })
        screenRoot.querySelectorAll("label").forEach(label=>label.addEventListener("mouseover",event=>{
          let options = this.parent.data.selectedOptions[this.data.productIndex];
          let input = screenRoot.querySelector(`#${label.getAttribute("for")}`);
          
          options[parseInt(input.dataset.optionIndex)] = input.value;
          
          let selectedVariant = this.parent.selectedVariant(parseInt(this.data.productIndex),options);
          
          let totalPrice = 0;
          this.parent
          if (parseInt(selectedVariant.price)==0) {
              selectedVariant = this.parent.data.parentVariants[0];
          }
          if (selectedVariant.mapTo) {
            let possibleVariant = this.parent.data.parentVariants.find(variant=>variant.id==selectedVariant.mapTo.id)
            if (possibleVariant) {
              selectedVariant = possibleVariant;
            }
          }
          
          document.dispatchEvent(new CustomEvent("sorcistino:update:price",{bubbles:true,detail:selectedVariant.price}))
        }))
      }
      
    }
    title() {
 
      return `<h2 class="h2 progress-bar-heading js-choose-style-heading js-steps-heading js-steps-title d-none d-lg-block">Choose your ${this.data.option}</h2>`
    }
}
class TykablesGearSelectionScreen extends TykablesSubscriptionScreen {
  preserve() {
    return true;
  }
  title() {
   return `<h2 class="h2 progress-bar-heading js-choose-style-heading js-steps-heading js-steps-title d-none d-lg-block">${this.data.title}</h2>`
  }
  render() {
      let product = this.parent.data.product[this.data.productIndex]
      this.parent.setContent(`
        <div class="panels" data-uuid="${this.uuid}">
          <div class="rounded-section db-column db-image-column js-db-image-column d-flex justify-content-center align-items-center">
            <div class="image-wrapper js-image-wrapper">
              <img src="${this.parent.imageFor()}" alt="" width="537" height="538" class="no-pointer-events" style="width:537;height:auto">
            </div>
          </div>
          <div class="rounded-section db-column db-main-column js-main-column d-flex justify-content-center align-items-center">
            <div class="inner">
              <div class="eyebrow color-poppy h5">
                Subscriptions
              </div>
              <h2 class="h1 db-heading first-heading js-first-heading">
                Select your Style
              </h2>
              <div class="h1 db-heading last-heading js-last-heading d-none"></div>
                <div class="review-app-wrapper body2 pdp-stars"></div>
                  <h3 class="h5 choose-option js-choose-option-Size js-choose-option"></h3>
                    <div class="switch-field js-switch-field switch-field-Size">
                      ${this.data.products.map((value,index)=>`
                        <input type="radio" id='${value.id}-${index}' name="${value.id}-${index}" value='${value.id}' class="js-variant-button variant-button js-variant-button0-radio1 js-style-button"}>
                        <label for='${value.id}-${index}' class="cta">${value.title.split(" ").pop()}</label>
                      `).join("\n")}
                    </div><!--
                    <div class="price-add-wrapper d-flex w-100 justify-content-between align-items-center flex-wrap flex-lg-nowrap">
                      <span class="h3 db-box-price js-box-price d-block js-summary-price">$<span class="money"></span></span>
                    </div>-->
                    <div class="body2 body-copy textile js-body-copy">
                      <div class="js-hero-copy"><p></p></div>
                      <div class="d-none js-last-copy"></div>
                    </div>
                  </div>
                </div>
              </div>
      `);
    }
    setupEvents() {
      let screenRoot = this.screenRoot();
      if (screenRoot) {
        screenRoot.querySelectorAll("input").forEach(option=>option.addEventListener("click",event=>{
          this.parent.getProduct(option.value)
        }))
      } 
    }
}
class TykablesSubscriptionFinalScreen extends TykablesSubscriptionScreen {
  render() {
  let lastPageContent = document.querySelector("#lastpage").innerHTML;
    //let lastPageContent = "";
   this.parent.setContent(
     `<div class="panels" data-uuid="${this.uuid}">
          <div class="rounded-section db-column db-image-column js-db-image-column d-flex justify-content-center align-items-center">
            <div class="rebuy"></div>
          </div>
          <div class="rounded-section db-column db-main-column js-main-column d-flex justify-content-center align-items-center">
            <div class="inner last-page">
              <div class="eyebrow color-poppy h5">
                ${this.parent.widgetTitle()}
              </div>
              <div class="price-add-wrapper d-flex w-100 justify-content-between align-items-center flex-wrap flex-lg-nowrap">
                <span class="h3 db-box-price js-box-price d-block js-summary-price">$<span class="money">${this.parent.displayPrice()}</span></span>
              </div>
              <h2 class="h1 db-heading first-heading js-first-heading">
                ${this.data.title}
              </h2>
              <div class="h1 db-heading last-heading js-last-heading d-none"></div>
                ${lastPageContent}
              </div>
              
   `)
    $('.product-list-subscription').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]

});

  }
  setupEvents() {
    this.screenRoot().querySelector(".js-cart").addEventListener("click",event=>location.href="/cart");
    let widget = document.querySelector(`.rebuy-holder [data-rebuy-id="${this.parent.config.rebuy_id}"]`);
    if (widget) {
      widget.parentNode.removeChild(widget);
      this.screenRoot().querySelector(".rebuy").appendChild(widget);
    }
  }
  title() {
 
      return `<h2 class="h2 progress-bar-heading js-choose-style-heading js-steps-heading js-steps-title d-none d-lg-block">${this.data.title}</h2>`
    }
}

class TykablesCartChecker extends CnR {
  constructor(options={}) {
    super(options)
    window.fetch("/cart.js").then(response=>response.json()).then(cart=>{
      let zeroItems = {}
      cart.items.forEach(item=>{
        if (item.final_price<=0 && item.product_type=="OPTIONS_HIDDEN_PRODUCT") {
          zeroItems[item.key] = 0;
        }
      })
      if (Object.keys(zeroItems).length>0) {
        this.updateCart({updates:zeroItems}).then(response=>{
          if (location.href.includes("/cart")) {
            location.href="/cart?refresh"
          }
        })
      }
    })
  }
}